export enum OrganizationFeatureFlag {
  FrenchJournals = 'frenchjournals',
}
